import type { DocumentLifecycleStatus } from "@asap/shared/schemas/document.schemas";

type DialogToOpen = "record" | "verification";

export function getDialogToOpen(lifecycleStatus?: DocumentLifecycleStatus): DialogToOpen {
  if (!lifecycleStatus) return "verification";
  if (lifecycleStatus === "failed") return "verification";
  if (lifecycleStatus === "required") return "verification";
  return "record";
}
